// extracted by mini-css-extract-plugin
export var check = "transition-day-button-module--check--a3840";
export var close = "transition-day-button-module--close--02c02";
export var container = "transition-day-button-module--container--e5ac9";
export var dayNumber = "transition-day-button-module--day-number--d482a";
export var dayText = "transition-day-button-module--day-text--e7096";
export var done = "transition-day-button-module--done--fcddb";
export var iconBox = "transition-day-button-module--icon-box--b5e26";
export var partial = "transition-day-button-module--partial--3137d";
export var plus = "transition-day-button-module--plus--8e448";
export var preview = "transition-day-button-module--preview--51c33";
export var today = "transition-day-button-module--today--645aa";